module.exports = __webpack_public_path__ + "static/img/mastercard.3c036285.svg";